import styled from 'styled-components'
import { BLUE } from '../../../../styles/colors.style'
import { breakpoints } from './../../../../constants/breakpoits.constants'
export const DestinationsContainer = styled.div`
	.title-info {
		font-weight: 600;
		text-align: center;
		margin: 4rem 0;
		color: ${BLUE};
		font-size: 4rem;
	}

	.images {
		display: flex;
		flex-direction: row;
		div {
			margin: 1em 40px;
		}
		@media (max-width: ${breakpoints.MOBILE}px) {
			display: 'flex' !important;
			flex-direction: column;
			div {
				margin: 0.3em 0;
			}
		}
	}
`
